import React, { useContext, useEffect, useState } from "react";
import DisplayNotes from "components/notes/components/display-notes";
import { ShipmentContext } from "components/shipment-editor/contexts";
import { useNotes } from "shared/hooks/api";
import { TaskType } from "shared/taskTypeMap";

export const ReadOnlyShipmentNotes = () => {
    const { shipmentData } = useContext(ShipmentContext);
    const [showShipmentNotesOnly, setShowShipmentNotesOnly] = useState(true);
    const { data: notes, isSuccess } = useNotes({ clientCode: shipmentData.cxHClient ? shipmentData.cxHClient.code : shipmentData.cxHCompany, showAllNotes: false });
    const [readOnlyNotes, setReadOnlyNotes] = useState([]);

    const handleNotesFilter = () => {
        setShowShipmentNotesOnly(!showShipmentNotesOnly);
    };

    useEffect(() => {
        if (isSuccess && notes) {
            setReadOnlyNotes(notes);
        }
    }, [isSuccess, notes]);

    useEffect(() => {
        if (notes) {
            setReadOnlyNotes(() => notes.filter(({ taskType }) => (showShipmentNotesOnly ? !taskType || taskType === TaskType.SHIPMENT : !showShipmentNotesOnly)));
        }
    }, [showShipmentNotesOnly, notes]);

    return (
        <fieldset>
            <legend>Client Notes</legend>
            {readOnlyNotes.length === 0 ? <p>No notes to display</p> : <DisplayNotes notes={readOnlyNotes} displayNoteType={true} allowArchive={false} />}
            <button className="button -text" onClick={handleNotesFilter}>
                {showShipmentNotesOnly ? "Show All Notes" : "Filter Shipment Notes"}
            </button>
        </fieldset>
    );
};
